module.exports = __webpack_public_path__ + "static/media/baoxiaoliucheng.e0ddc560.png";